import { DateTime } from 'luxon'

import { hasReachedMaxPerUser } from '@/features/store/lib/allowance'
import { checkBlockCondition, type GetProgress } from '@/shared/lib/blocker/checkBlockCondition'
import type { RewardItem, RewardWithUnderscores } from '@/types/reward'

/** Status devolvido por `features/store/lib/storeHours#resolveStoreHours`. */
export type StoreStatus = 'loading' | 'unscheduled' | 'open' | 'soon' | 'closed'

/** Item como sai de `useRewardsStore().rewardItems`: `sold_out` derivado lá, `image` vinda do serializer. */
export type StoreNudgeCatalogItem = RewardItem & {
  sold_out?: boolean
  image?: { file?: { url?: string | null } | null } | null
}

/** Pedido de resgate como sai de `useRewardsStore().rewardRequests`. */
export type StoreNudgeRewardRequest = {
  reward_id: number
  status: string
  quantity?: number
  expires_at?: string | null
}

export type RedeemableContext = {
  reward: RewardWithUnderscores | undefined
  storeStatus: StoreStatus
  requestsOfReward: StoreNudgeRewardRequest[]
  getProgress: GetProgress
  now?: DateTime
}

export const isStoreOpen = (status: StoreStatus) =>
  status === 'open' || status === 'unscheduled'

/**
 * "Resgatável agora": o que o popup pode prometer sem mentir. Reusa os mesmos
 * critérios da vitrine — estoque, janela, cota e condição de desbloqueio — em
 * vez de reimplementá-los. `coin` nulo é tratado como não resgatável por
 * cautela: o backend exige preço em item ativo, mas o cliente não confia nisso.
 */
export const isRedeemableNow = (
  item: StoreNudgeCatalogItem,
  { reward, storeStatus, requestsOfReward, getProgress, now }: RedeemableContext
): boolean => {
  if (!reward || !reward.active) return false
  if (!item.active || item.sold_out) return false
  if (item.coin == null) return false
  if (!isStoreOpen(storeStatus)) return false
  if (!checkBlockCondition(reward._blockCondition, getProgress).unlocked) {
    return false
  }
  if (
    hasReachedMaxPerUser(
      requestsOfReward,
      reward.max_quantity_per_user,
      now ?? DateTime.now()
    )
  ) {
    return false
  }
  return true
}
